import Base from './init/base';
import Options from './init/options';

class Init {
    /**
     * @param {string} typeName
     * @param {Object} data
     */
    constructor({typeName = '', data = {}}) {
        let method = `on${typeName[0].toUpperCase()}${typeName.slice(1)}`;
        this[method](data);
    }

    /**
     * @param {{typeName:String, data:Object}|{data:Object}} data
     * @return {Init}
     */
    static run(data) {
        return new Init(data);
    }

    /**
     * @param {{modal: Modal, formData: Object}} data
     */
    onBase(data) {
        Base.run(data);
    }

    onOptions(data) {
        Options.run(data);
    }
}

export default Init;
